module.exports = __webpack_public_path__ + "img/address.2e9a6a0.svg";